import { appConstants } from "../constants/appConstants"

function incrementLoadingCounter() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.INCREMENT_COUNTER,
    })
  }
}

function decrementLoadingCounter() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.DECREMENT_COUNTER,
    })
  }
}

function reset() {
  return (dispatch: any) => {
    dispatch({
      type: appConstants.RESET,
    })
  }
}

const loaderAction = {
  incrementLoadingCounter,
  decrementLoadingCounter,
  reset
}

export default loaderAction
